import { Box, Flex, Spinner, Text } from '@chakra-ui/react';
import { Contest, LeaderboardStatPeriod, League } from 'models';

interface Props {
  selectedLeague?: League;
  onLeagueChange: (league: League) => void;
  onContestChange?: (contestId: number) => void;
  leagues: League[];
  contests?: Contest[];
  selectedContestId?: number | null;
  stat?: LeaderboardStatPeriod;
  isLoading?: boolean;
}

const LeagueFilter = ({
  selectedLeague,
  leagues,
  onLeagueChange,
  onContestChange,
  contests,
  selectedContestId,
  isLoading = false,
}: Props) => {
  const handleLeagueFilterClick = (league: League) => {
    onLeagueChange(league);
  };

  const handleContestClick = (contestId: number) => {
    if (onContestChange) {
      onContestChange(contestId);
    }
  };

  if (isLoading) {
    return (
      <Flex
        w="100%"
        flexDirection="column"
        justifyContent="space-between"
        alignItems="center"
        mt="8px"
        mb="14px"
        backgroundColor="#292929"
        py="12px"
      >
        <Spinner size="sm" color="#F83C3C" />
      </Flex>
    );
  }

  if (!leagues || leagues.length === 0) {
    return (
      <Flex
        w="100%"
        flexDirection="column"
        justifyContent="space-between"
        alignItems="center"
        mt="8px"
        mb="14px"
        backgroundColor="#292929"
        py="12px"
      >
        <Box
          fontFamily="Special Gothic Expanded One"
          fontSize="12px"
          textTransform="uppercase"
          fontWeight="400"
          lineHeight="1.2"
          color="white"
          opacity={0.6}
        >
          No contests available
        </Box>
      </Flex>
    );
  }

  return (
    <Flex
      w="100%"
      flexDirection="column"
      justifyContent="space-between"
      alignItems="center"
      mt="8px"
      mb="14px"
      backgroundColor="#292929"
    >
      <Flex
        w="100%"
        px="15px"
        gap="12px"
        alignItems="center"
        justifyContent="center"
        borderTop="1px solid rgba(51, 51, 51, 1)"
        borderBottom="1px solid rgba(51, 51, 51, 1)"
        pt="12px"
        pb="12px"
      >
        {leagues.map((league) => (
          <Box
            key={league}
            fontFamily="Special Gothic Expanded One"
            fontSize="12px"
            textTransform="uppercase"
            fontWeight="400"
            lineHeight="1.2"
            cursor="pointer"
            transition="opacity 0.3s ease-in-out"
            color={selectedLeague === league ? '#F83C3C' : 'white'}
            onClick={() => handleLeagueFilterClick(league)}
          >
            {league}
          </Box>
        ))}
      </Flex>

      {contests && contests.length > 1 && onContestChange && (
        <Flex
          w="100%"
          px="15px"
          gap="8px"
          alignItems="center"
          justifyContent="center"
          borderBottom="1px solid rgba(51, 51, 51, 1)"
          pt="8px"
          pb="8px"
          flexWrap="wrap"
        >
          <Text
            fontSize="10px"
            color="rgba(255, 255, 255, 0.6)"
            mr="8px"
            fontFamily="Special Gothic Expanded One"
            textTransform="uppercase"
          >
            Contest:
          </Text>
          {contests.map((contest) => (
            <Box
              key={contest.id}
              fontSize="10px"
              cursor="pointer"
              transition="opacity 0.3s ease-in-out"
              color={selectedContestId === contest.id ? '#F83C3C' : 'rgba(255, 255, 255, 0.8)'}
              onClick={() => handleContestClick(contest.id)}
              fontFamily="Special Gothic Expanded One"
              textTransform="uppercase"
              _hover={{
                opacity: 0.8,
              }}
            >
              {contest.league}
            </Box>
          ))}
        </Flex>
      )}
    </Flex>
  );
};

export default LeagueFilter;
